export enum FiLoginType {
    DesktopLoginPassword = 1,
    MobileLoginPassword = 2,
    MobileEmailPassword = 3,
    MobileMagicLink = 4,
}
